const FIREBASE_API_KEY = 'AIzaSyCOhL_nAuACQa5YnPOkk4FgvbeZ28ZnV_o'
const FIREBASE_PROJECT_ID = 'project-48710fa3-79f5-4b91-a17'

export type FirebaseSignupResult = {
  localId: string
  idToken: string
  refreshToken: string
  email: string
  expiresIn: string
}

export async function createFirebaseMember({
  email,
  password,
  handle,
}: {
  email: string
  password: string
  handle: string
}): Promise<FirebaseSignupResult> {
  const authResponse = await fetch(
    `https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=${FIREBASE_API_KEY}`,
    {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({email, password, returnSecureToken: true}),
    },
  )

  const authData = await authResponse.json()
  if (!authResponse.ok) {
    throw new Error(authData.error?.message || 'Firebase signup failed')
  }

  const result = authData as FirebaseSignupResult
  const memberResponse = await fetch(
    `https://firestore.googleapis.com/v1/projects/${FIREBASE_PROJECT_ID}/databases/(default)/documents/mont2Members?documentId=${encodeURIComponent(result.localId)}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${result.idToken}`,
      },
      body: JSON.stringify({
        fields: {
          uid: {stringValue: result.localId},
          email: {stringValue: result.email},
          handle: {stringValue: handle},
          createdAt: {timestampValue: new Date().toISOString()},
        },
      }),
    },
  )

  if (!memberResponse.ok) {
    const memberData = await memberResponse.json()
    throw new Error(
      memberData.error?.message || 'Firestore member creation failed',
    )
  }

  localStorage.setItem(
    'mont2.firebase.session',
    JSON.stringify({
      ...result,
      handle,
      createdAt: Date.now(),
    }),
  )

  return result
}
